/**
 * SyncFlow Login Logic
 */

// Функція входу
async function handleLogin() {
    const usernameInput = document.getElementById('username') as HTMLInputElement | null;
    const passwordInput = document.getElementById('password') as HTMLInputElement | null;
    const username = usernameInput ? usernameInput.value : '';
    const password = passwordInput ? passwordInput.value : '';

    if (!username || !password) {
        if (typeof (window as any).showMessage === 'function') {
            (window as any).showMessage('Будь ласка, заповніть всі поля', 'error');
        } else {
            alert('Будь ласка, заповніть всі поля');
        }
        return;
    }

    // Показуємо індикатор завантаження
    const submitBtn = document.querySelector('.submit-btn') as HTMLButtonElement | null;
    const btnText = submitBtn ? submitBtn.querySelector('span') : null;
    const originalText = btnText ? btnText.textContent : '';
    
    if (btnText) btnText.textContent = 'Вхід...';
    if (submitBtn) {
        submitBtn.classList.add('loading');
        submitBtn.disabled = true;
    }

    try {
        const response = await fetch('/api/auth.php?action=login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                username: username,
                password: password
            })
        });

        const data = await response.json();

        if (data.success) {
            // Зберігаємо інформацію про користувача
            localStorage.setItem('currentEnvironment', data.user.environment || 'local');
            localStorage.setItem('currentDbType', data.user.db_type || 'local');
            localStorage.setItem('currentUser', JSON.stringify(data.user));

            // Миттєвий перехід на головну після успішного входу
            window.location.href = 'index.html';
        } else {
            if (typeof (window as any).showMessage === 'function') {
                (window as any).showMessage('Помилка: ' + data.message, 'error');
            } else {
                alert('Помилка: ' + data.message);
            }
        }
    } catch (error) {
        console.error('Помилка: ', error);
        if (typeof (window as any).showMessage === 'function') {
            (window as any).showMessage('Помилка підключення до сервера', 'error');
        } else {
            alert('Помилка підключення до сервера');
        }
    } finally {
        // Відновлюємо кнопку
        if (btnText && originalText) btnText.textContent = originalText;
        if (submitBtn) {
            submitBtn.classList.remove('loading');
            submitBtn.disabled = false;
        }
        
        // Очищення пароля для безпеки
        if (passwordInput) passwordInput.value = '';
    }
}

// Функція перемикання видимості поля пароля
function togglePassword() {
    const passwordInput = document.getElementById('password') as HTMLInputElement | null;
    const eyeIcon = document.getElementById('eye-icon');
    
    if (!passwordInput || !eyeIcon) return;

    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        eyeIcon.className = 'ri-eye-line';
    } else {
        passwordInput.type = 'password';
        eyeIcon.className = 'ri-eye-off-line';
    }
}

// Функція для перевірки авторизації
async function checkAuth() {
    try {
        const response = await fetch(`/api/check-session.php?_=${Date.now()}`);
        const data = await response.json();

        if (data.success) {
            console.log('Користувач авторизований: ', data.user.username);
            // Якщо користувач вже авторизований, перенаправляємо на головну
            if (window.location.pathname.includes('login.html')) {
                window.location.href = 'index.html';
            }
            return data.user;
        } else {
            console.log('Користувач не авторизований');
            return null;
        }
    } catch (error) {
        console.error('Помилка перевірки авторизації: ', error);
        return null;
    }
}

// Обробка натискання Enter в полях вводу
document.addEventListener('DOMContentLoaded', function() {
    // Перевірка авторизації при завантаженні
    checkAuth();

    const usernameInput = document.getElementById('username');
    const passwordInput = document.getElementById('password');

    if (usernameInput && passwordInput) {
        usernameInput.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                passwordInput.focus();
            }
        });

        passwordInput.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                handleLogin();
            }
        });
    }
});


// --- Auto-generated exports for Vite modules ---
(window as any).handleLogin = handleLogin;
(window as any).checkAuth = checkAuth;
(window as any).togglePassword = togglePassword;
